import { createSlice } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
import colors, { layoutColors } from "../config/colors";

const initialState = {
  token: localStorage.getItem(process.env.REACT_APP_TOKEN) || null,
  userId: localStorage.getItem(process.env.REACT_APP_USER_ID) || null,
  userType:
    localStorage.getItem(process.env.REACT_APP_USER_ACCOUNT_TYPE) || null,
  isLoggedIn: !!localStorage.getItem(process.env.REACT_APP_TOKEN),
  userName: localStorage.getItem(process.env.REACT_APP_USER_Name) || null,
  tracking: false,
};

export const counterSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, { payload }) => {
      localStorage.setItem(process.env.REACT_APP_TOKEN, payload.token);
      localStorage.setItem(process.env.REACT_APP_USER_ID, payload.userId);
      localStorage.setItem(process.env.REACT_APP_USER_Name, payload.name);
      localStorage.setItem(
        process.env.REACT_APP_USER_ACCOUNT_TYPE,
        payload.userType
      );
      state.token = payload.token;
      state.userId = payload.userId;
      state.userType = payload.userType;
      state.userName = payload.name;
      state.isLoggedIn = true;
    },
    logout: (state) => {
   
      state.token = null;
      state.userType = null;
      state.userName = null;
      state.isLoggedIn = false;
      localStorage.removeItem(process.env.REACT_APP_USER_Name);
      localStorage.removeItem(process.env.REACT_APP_USER_ID);
      localStorage.removeItem(process.env.REACT_APP_TOKEN);
      localStorage.removeItem(process.env.REACT_APP_USER_ACCOUNT_TYPE);
    },
    Settracking: (state, { payload }) => {
      state.tracking = payload; // Set isAdmin directly
      localStorage.setItem("tracking", payload)
    },
  },
});

// Action creators are generated for each case reducer function
export const { login, logout,Settracking } = counterSlice.actions;

export default counterSlice.reducer;
